import OurMissionImage from "../../../assets/images/OurMission.png";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/ShieldIcon.svg";

const OurMission = () => {
  return (
    <section
      // className="plan"
      // style={{ backgroundImage: `url(${BlueBgImage})` }}
      className=" plan section-bg section-bg--white"
    >
      <div className="plan__container">
        {/* LEFT CONTENT */}
        <div className="plan__image-wrap">
          <img src={OurMissionImage} alt="Our Mission" />
        </div>
        {/* RIGHT IMAGE */}
        <div className="plan__content">
          <h4 className="primary">
            OUR MISSION
            <div className="divider" />
          </h4>
          <div className="content primary">
            Our mission is simple: to keep children in the schools they love. We
            provide specialist fee protection advice to independent school
            families, built on responsible financial planning and a genuine{" "}
            <span className="content-medium primary">
              commitment to continuity of education.
            </span>
          </div>
          <div className="content-medium primary">
            A small act for your school.{" "}
            <span className="content-medium accent">
              A significant one for the families who need it most.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
